// "Review this game" on the end dialog: the replay it opens asks for the review at once (design 12 §3). Kept apart from ui/Review,
// so the pages that only say which game (Home, History, a profile, the table) don't load the review's code with their own: it
// was 9.5 KB of every first visit (design 11 §9).

let wanted: string | null = null;

/** The game whose replay should ask for its review when it opens. */
export const reviewOnOpen = (gameId: string) => void (wanted = gameId);

/** Whether the review of `id` was asked for, forgetting it when `done`. */
export function reviewWanted(id: string, done = false): boolean {
  const is = wanted === id;
  if (is && done) wanted = null;
  return is;
}
